// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1vSP4","tabs":"style_tabs__1ZBuP","item":"style_item__2bMA_","active":"style_active__RhDHL","box":"style_box__3gLuE"};